export default "__VITE_ASSET__jdPMehbd__"